const AuthPage = ({
  needsBootstrap,
  bootstrapUser,
  canDevReset,
  authForm,
  setAuthForm,
  onSubmit,
  loading,
  message,
}) => {
  return (
    <main className="auth-screen" dir="rtl">
      <section className="auth-panel">
        <div className="auth-brand"><span className="brand-mark">L</span><span>Calmpi</span></div>
        <p className="eyebrow">מרכז הבקרה</p>
        <h1>{needsBootstrap ? 'יצירת משתמש מערכת ראשון' : 'כניסה לפאנל'}</h1>
        <p className="auth-subtitle">כל מה שצריך לניהול המקומות, המשתמשים והפעילות — במקום אחד.</p>
        <form onSubmit={onSubmit} className="auth-form">
          {needsBootstrap && (
            <label>
              שם
              <input
                value={authForm.name}
                onChange={(e) =>
                  setAuthForm({
                    ...authForm,
                    name: e.target.value,
                  })
                }
                required
              />
            </label>
          )}
          <label>
            אימייל
            <input
              type="email"
              value={authForm.email}
              onChange={(e) =>
                setAuthForm({
                  ...authForm,
                  email: e.target.value,
                })
              }
              required
            />
          </label>
          <label>
            סיסמה
            <input
              type="password"
              minLength={needsBootstrap || canDevReset ? 8 : undefined}
              value={authForm.password}
              onChange={(e) =>
                setAuthForm({
                  ...authForm,
                  password: e.target.value,
                })
              }
              required
            />
          </label>
          {message && <p className="message error">{message}</p>}
          <button disabled={loading}>
            {loading ? 'רגע...' : needsBootstrap ? 'יצירת אדמין' : 'כניסה'}
          </button>
        </form>
      </section>
    </main>
  );
};
export default AuthPage;
